import { Edit, Delete } from "@mui/icons-material";

import { TableActions } from "../../components/v3";

export const getLeadColumns = (handleActions, editLead, deleteLead) => {
  const headers = [
    { field: "sl", headerName: "Sl No", flex: 0.5, sortable: false },
    { field: "contactName", headerName: "Name", flex: 2, sortable: true },
    { field: "mobile", headerName: "Mobile", flex: 1.5, sortable: false },
    { field: "status", headerName: "Status", flex: 1.5, sortable: false },
    { field: "priority", headerName: "Priority", flex: 2, sortable: false },
  ];

  if (editLead || deleteLead) {
    headers.push({
      field: "actions",
      headerName: "Action",
      sortable: false,
      flex: 1,
      renderCell: (params) => {
        const actions = [];

        if (editLead) {
          actions.push({
            icon: Edit,
            type: "edit",
            label: "Edit",
            onClick: handleActions,
          });
        }

        if (deleteLead) {
          actions.push({
            icon: Delete,
            type: "delete",
            label: "Delete",
            onClick: handleActions,
          });
        }

        return <TableActions item={params} actions={actions} />;
      },
    });
  }

  return headers;
};

/**
 * Route paths for the CRM Pro module.
 * Single source of truth — reuse these instead of hard-coding `/crm-pro...` strings.
 */
export const CRM_PRO_ROUTES = {
  root: "/crm-pro",
  dashboard: "/crm-pro/dashboard",
  leads: "/crm-pro/leads",
  leadDetails: "/crm-pro/leads/:id",
} as const;
